// Generated by purs version 0.15.15
import * as Data_Show from "../Data.Show/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var show2 = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var RGB = /* #__PURE__ */ (function () {
    function RGB(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RGB.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RGB(value0, value1, value2);
            };
        };
    };
    return RGB;
})();
var RGBA = /* #__PURE__ */ (function () {
    function RGBA(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    };
    RGBA.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return new RGBA(value0, value1, value2, value3);
                };
            };
        };
    };
    return RGBA;
})();
var Named = /* #__PURE__ */ (function () {
    function Named(value0) {
        this.value0 = value0;
    };
    Named.create = function (value0) {
        return new Named(value0);
    };
    return Named;
})();
var NoColor = /* #__PURE__ */ (function () {
    function NoColor() {

    };
    NoColor.value = new NoColor();
    return NoColor;
})();
var showColor = {
    show: function (v) {
        if (v instanceof RGB) {
            return "(RGB " + (show(v.value0) + (" " + (show(v.value1) + (" " + (show(v.value2) + ")")))));
        };
        if (v instanceof RGBA) {
            return "(RGBA " + (show(v.value0) + (" " + (show(v.value1) + (" " + (show(v.value2) + (" " + (show1(v.value3) + ")")))))));
        };
        if (v instanceof Named) {
            return "(Named " + (show2(v.value0) + ")");
        };
        if (v instanceof NoColor) {
            return "NoColor";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Color (line 17, column 10 - line 21, column 25): " + [ v.constructor.name ]);
    }
};
var printColor = function (v) {
    if (v instanceof RGB) {
        return "rgb(" + (show(v.value0) + ("," + (show(v.value1) + ("," + (show(v.value2) + ")")))));
    };
    if (v instanceof RGBA) {
        return "rgba(" + (show(v.value0) + ("," + (show(v.value1) + ("," + (show(v.value2) + ("," + (show1(v.value3) + ")")))))));
    };
    if (v instanceof Named) {
        return v.value0;
    };
    if (v instanceof NoColor) {
        return "None";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Color (line 24, column 14 - line 28, column 20): " + [ v.constructor.name ]);
};
var eqColor = {
    eq: function (x) {
        return function (y) {
            if (x instanceof RGB && y instanceof RGB) {
                return x.value0 === y.value0 && x.value1 === y.value1 && x.value2 === y.value2;
            };
            if (x instanceof RGBA && y instanceof RGBA) {
                return x.value0 === y.value0 && x.value1 === y.value1 && x.value2 === y.value2 && x.value3 === y.value3;
            };
            if (x instanceof Named && y instanceof Named) {
                return x.value0 === y.value0;
            };
            if (x instanceof NoColor && y instanceof NoColor) {
                return true;
            };
            return false;
        };
    }
};
export {
    RGB,
    RGBA,
    Named,
    NoColor,
    printColor,
    eqColor,
    showColor
};
